import { BallIcon } from '@/common/assets';

interface GoalscorerLastMatchProps {
  /** Localized section title, provided by the parent. */
  label: string;
  /** Names of goalscorers from the last match (home side). */
  homeScorers: string[];
  /** Names of goalscorers from the last match (away side). */
  awayScorers: string[];
}

export default function GoalscorerLastMatch({
  label,
  homeScorers,
  awayScorers,
}: GoalscorerLastMatchProps) {
  const hasAnyScorers = homeScorers.length > 0 || awayScorers.length > 0;

  if (!hasAnyScorers) {
    return null;
  }

  return (
    <div className="flex flex-col gap-[4px] items-center w-full font-robotoRegular font-normal">
      <span className="text-[12px] leading-[16px] text-pmw-label-secondary-light dark:text-pmw-label-secondary-dark">
        {label}
      </span>
      <div className="flex w-full items-center gap-[12px] text-[10px] leading-[16px] text-pmw-label-secondary-light dark:text-pmw-label-secondary-dark">
        <div className="flex-1 min-w-0">
          <p className="text-right">{homeScorers.join(', ')}</p>
        </div>
        <BallIcon className="size-[12px] shrink-0" />
        <div className="flex-1 min-w-0">
          <p>{awayScorers.join(', ')}</p>
        </div>
      </div>
    </div>
  );
}
